import {
    featureAppMemoryStoreDefinition,
    SharedFeatureAppMemoryStore
} from '@volkswagen-onehub/feature-app-memory-store';
import {ServiceRegistration} from './ServiceRegistration';

export function createFeatureAppMemoryStore(): ServiceRegistration<SharedFeatureAppMemoryStore> {
    return {definition: featureAppMemoryStoreDefinition};
}
